(() => {
  const selector = '[data-category-carousel]';
  const cleanups = new Map();

  function init(carousel) {
    if (carousel.dataset.categoryReady) return;
    const track = carousel.querySelector('[data-category-track]');
    const previous = carousel.querySelector('[data-category-previous]');
    const next = carousel.querySelector('[data-category-next]');
    if (!track || !previous || !next) return;
    carousel.dataset.categoryReady = 'true';

    const mobile = window.matchMedia('(max-width: 1000px)');
    const update = () => {
      const cannotScroll = !mobile.matches || track.scrollWidth <= track.clientWidth + 1;
      previous.hidden = cannotScroll || track.scrollLeft <= 1;
      next.hidden = cannotScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    };
    const move = (direction) => {
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const stride = track.clientWidth + gap;
      const page = Math.round(track.scrollLeft / stride) + direction;
      track.scrollTo({
        left: Math.max(0, page * stride),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };
    const back = () => move(-1);
    const forward = () => move(1);
    const resize = () => {
      if (!mobile.matches) track.scrollLeft = 0;
      update();
    };
    previous.addEventListener('click', back);
    next.addEventListener('click', forward);
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', resize, { passive: true });
    const observer = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
    observer?.observe(track);
    update();

    cleanups.set(carousel, () => {
      previous.removeEventListener('click', back);
      next.removeEventListener('click', forward);
      track.removeEventListener('scroll', update);
      window.removeEventListener('resize', resize);
      observer?.disconnect();
      delete carousel.dataset.categoryReady;
      cleanups.delete(carousel);
    });
  }

  const initAll = (scope) => scope.querySelectorAll(selector).forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((carousel) => cleanups.get(carousel)?.());
  });
})();
